import Papa from 'papaparse';
import { useMemo } from 'react';
import { GeneDataMap, TableDataType } from '../_types';
import { Trie } from '../_utils';

export const useCsvToTrieMap = (csvText: string) => {
  // CSV 텍스트를 파싱하여 geneDataMap과 geneTrie 생성 (useMemo 사용)
  return useMemo(() => {
    const geneDataMap: GeneDataMap = {};
    const geneTrie = new Trie();

    if (csvText) {
      Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true,
        step: (results: Papa.ParseStepResult<TableDataType>) => {
          const gene = results.data;
          if (gene.geneName) {
            const lowercaseName = gene.geneName.toLowerCase();
            geneDataMap[lowercaseName] = gene;
            geneTrie.insert(gene.geneName); // 원본 대소문자 유지하면서 Trie에 추가
          }
        },
        error: (error: Error) => {
          console.error('CSV 파싱 오류:', error);
        },
      });
    }
    return { geneDataMap, geneTrie };
  }, [csvText]);
};
